export type NumberCircleProps = {
  n: number
  size?: number
  winner?: boolean
}

export const NumberCircle = ({ n, size = 22, winner }: NumberCircleProps) => {
  const bg = winner
    ? 'var(--gilt)'
    : n === 2
      ? 'var(--podium-silver)'
      : n === 3
        ? 'var(--podium-bronze)'
        : 'var(--paper-3)'
  const color = winner || n <= 3 ? '#FFF8E8' : 'var(--ink-2)'
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: bg,
        color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'var(--font-mono)',
        fontWeight: 700,
        fontSize: size * 0.5,
        boxShadow: winner ? '0 0 0 2px rgba(0,0,0,.06), 0 1px 2px rgba(0,0,0,.18)' : 'none',
        flexShrink: 0,
      }}
    >
      {n}
    </div>
  )
}
